/**
 * Stored codes as words a person would read, for history and timeline lines.
 */

/** "ready_for_ranking" / "RUN_COMPLETE" / "detailedState" → "ready for ranking" / "run complete" / "detailed state". */
export function plainState(value: unknown): string {
  return (
    String(value ?? '')
      .replace(/_/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .trim()
      .toLowerCase() || 'nothing'
  );
}

/** An event type with no sentence of its own, as words: "ball_passed_up" → "Ball passed up". */
export function plainEventName(eventType: string): string {
  const words = plainState(eventType);
  return words.charAt(0).toUpperCase() + words.slice(1);
}
